import React from 'react'
import { withIcon } from '../../withIcon'

function HeadphonesOutlineIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path fillRule="evenodd" clipRule="evenodd" d="M12 4.625C10.044 4.625 8.16817 5.40201 6.78509 6.78509C5.40201 8.16817 4.625 10.044 4.625 12V12.7635C5.02488 12.5171 5.49584 12.375 6 12.375H7C8.44975 12.375 9.625 13.5503 9.625 15V18C9.625 19.4497 8.44975 20.625 7 20.625H6C4.55025 20.625 3.375 19.4497 3.375 18V12C3.375 9.71251 4.2837 7.51871 5.9012 5.9012C7.51871 4.2837 9.71251 3.375 12 3.375C14.2875 3.375 16.4813 4.2837 18.0988 5.9012C19.7163 7.51871 20.625 9.71251 20.625 12V18C20.625 19.4497 19.4497 20.625 18 20.625H17C15.5503 20.625 14.375 19.4497 14.375 18V15C14.375 13.5503 15.5503 12.375 17 12.375H18C18.5042 12.375 18.9751 12.5171 19.375 12.7635V12C19.375 10.044 18.598 8.16817 17.2149 6.78509C15.8318 5.40201 13.956 4.625 12 4.625ZM19.375 15C19.375 14.2406 18.7594 13.625 18 13.625H17C16.2406 13.625 15.625 14.2406 15.625 15V18C15.625 18.7594 16.2406 19.375 17 19.375H18C18.7594 19.375 19.375 18.7594 19.375 18V15ZM4.625 15V18C4.625 18.7594 5.24061 19.375 6 19.375H7C7.75939 19.375 8.375 18.7594 8.375 18V15C8.375 14.2406 7.75939 13.625 7 13.625H6C5.24061 13.625 4.625 14.2406 4.625 15Z" fill={color}/>
    </svg>
  )
}

export default withIcon(HeadphonesOutlineIcon)
